import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var KeyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M15.5 1a7.5 7.5 0 11-2.717 14.493l-.348 1.984a1 1 0 01-1.062.824l-.11-.014-1.753-.333-.375 2.132a1 1 0 01-1.026.826l-.115-.011-2.527-.4-.796 1.888a1 1 0 01-.992.609l-.115-.016-2.75-.521a1 1 0 01-.807-.864L0 21.478v-4.174a1 1 0 01.25-.662l.087-.086 7.757-6.868A7.5 7.5 0 0115.5 1zm0 2a5.5 5.5 0 00-5.464 6.132l.044.312.06.098a1 1 0 01-.138 1.118l-.09.089L2 17.755v2.895l1.143.217.786-1.864a1 1 0 01.964-.61l.113.01 2.33.369.38-2.162a1 1 0 011.061-.824l.11.014 1.753.333.375-2.132a1 1 0 011.158-.812l-.053-.007a.996.996 0 01.68.111A5.5 5.5 0 1015.5 3zM17 5a2 2 0 110 4 2 2 0 010-4z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
KeyIcon.isCarinaIcon = true;
export default KeyIcon;
